import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Button, Form, Icon, Label, Popup } from "semantic-ui-react";
import ScrollableDropdown from "../../../common/scrollableDropDown";

export const CampaignsField = ({
  values,
  updateValues,
  campaigns,
  campaignsLoading,
  advertisersLoading,
  trimmingSearch,
  resetSelectedCampaigns,
  campaignSearchQuery,
  setCampaignSearchQuery,
  performSearchCampaignsDebounced,
  tooltipMessage,
  resetCampaigns,
}) => {
  const intl = useIntl();
  const disabled = !values.advertiser_id || campaignsLoading;

  return (
    <Form.Field
      className="filter-field"
      style={{ flexGrow: 1 }}
    >
      <label>
        {intl.formatMessage({
          id: "LABEL_CAMPAIGNS",
          defaultMessage: "Campaigns",
        })}
        {tooltipMessage && (
          <Popup
            inverted
            style={{ marginLeft: "0.5em" }}
            content={tooltipMessage}
            size="mini"
            trigger={
              <Icon
                name="help circle"
                style={{ position: "relative" }}
                className="cursor-help"
              />
            }
          />
        )}
        <Button
          compact
          size="mini"
          className={values.campaign_ids.length ? "btn-clear" : "btn-clear hidden"}
          type="button"
          style={{ margin: "-0.589286em 0.5625em" }}
          onClick={resetSelectedCampaigns}
        >
          {intl.formatMessage({
            id: "BTN_CLEAR",
            defaultMessage: "Clear",
          })}
        </Button>
      </label>
      <ScrollableDropdown
        id="campaign_dropdown"
        data-id="campaigns"
        defaulttrigger={
          <Label style={{ float: "left" }}>
            {intl.formatMessage({
              id: "VALUE_ALL_CAMPAIGNS",
              defaultMessage: "All campaigns",
            })}
          </Label>
        }
        noResultsMessage={intl.formatMessage({
          id: "EMPTY_SEARCH_RESULTS",
          defaultMessage: "No results found",
        })}
        multiple
        search={!advertisersLoading && trimmingSearch}
        className="selection scrollable-droprown"
        disabled={disabled}
        loading={campaignsLoading}
        options={[
          {
            key: "ALL_CAMPAIGNS",
            text: intl.formatMessage({
              id: "VALUE_ALL_CAMPAIGNS",
              defaultMessage: "All campaigns",
            }),
            value: "ALL_CAMPAIGNS",
          },
          ...campaigns,
        ]}
        name="campaign_ids"
        value={values.campaign_ids}
        searchQuery={campaignSearchQuery}
        onChange={(_e, input) => {
          updateValues({
            // biome-ignore lint/style/useNamingConvention: <server prop>
            campaign_ids: input.value.includes("ALL_CAMPAIGNS") ? [] : input.value,
          });
          setCampaignSearchQuery("");
          resetCampaigns();
        }}
        onSearchChange={(_event, { searchQuery }) => {
          setCampaignSearchQuery(searchQuery);
          performSearchCampaignsDebounced(searchQuery);
        }}
      />
    </Form.Field>
  );
};

CampaignsField.propTypes = {
  values: PropTypes.object.isRequired,
  updateValues: PropTypes.func.isRequired,
  campaigns: PropTypes.array.isRequired,
  campaignsLoading: PropTypes.bool.isRequired,
  advertisersLoading: PropTypes.bool,
  trimmingSearch: PropTypes.func.isRequired,
  resetSelectedCampaigns: PropTypes.func.isRequired,
  campaignSearchQuery: PropTypes.string.isRequired,
  setCampaignSearchQuery: PropTypes.func.isRequired,
  performSearchCampaignsDebounced: PropTypes.func.isRequired,
  tooltipMessage: PropTypes.string,
  resetCampaigns: PropTypes.func.isRequired,
};
